import QueueAPI from '@/api/queue'

import Vue from 'vue'

export default {
    namespaced: true,
    state: {
        orders: [],
        joined_tables: {},
        error: null
    },
    mutations: {
        setOrders(state, payload) {
            state.orders = payload;
        },
        setError(state, err) {
            state.error = err;
        },

        setOrderStatus(state, payload) {
            state.orders[payload.index].status = payload.status;
        },

        setOrderReason(state, payload) {
            Vue.set(state.orders[payload.index], 'reason', payload.reason);
        },

        setOrderWaiter(state, payload) {
            Vue.set(state.orders[payload.index], 'waiter', payload.waiter);
        },

        setOrderPayMethod(state, payload) {
            Vue.set(state.orders[payload.index], 'pay_method', payload.pay_method);
        },

        setOrderDiscount(state, payload) {
            Vue.set(state.orders[payload.index], 'discount', payload.discount);
        },

        setOrderWaitingTime(state, payload) {
            Vue.set(state.orders[payload.index], 'waiting_time', payload.waiting_time);
        },

        setOrderProcessedDate(state, payload) {
            Vue.set(state.orders[payload.index], 'processed_at', new Date());
        },

        setOrderServedAt(state, payload) {
            Vue.set(state.orders[payload.index], 'served_at', new Date());
        },

        changeOrderItemQuantity(state, payload) {
            const old_qty = state.orders[payload.index].list[payload.item_index].quantity;

            const new_qty = old_qty + payload.delta;

            Vue.set(state.orders[payload.index].list[payload.item_index], 'quantity', new_qty);

            if (new_qty <= 0) {
                state.orders[payload.index].list.splice(payload.item_index, 1);
            }
        },

        addItemToOrderList(state, payload) {
            state.orders[payload.index].list.push(payload.item);
        },

        removeOrder(state, index) {
            state.orders.splice(index, 1);
        },

        addOrder(state, order) {
            state.orders.push(order);
        },

        updateOrder(state, order) {
            const index = state.orders.findIndex((o) => o._id === order._id);

            Vue.set(state.orders, index, order);
        },

        moveOrder(state, payload) {
            state.orders[payload.index].section = payload.section;
            state.orders[payload.index].table = payload.table;
        },

        setJoinedTables(state, payload) {
            state.joined_tables = payload;
        },

        joinTables(state, payload) {
            const section = `${payload.section}`;

            if (!state.joined_tables[section]) {
                Vue.set(state.joined_tables, section, []);
            }

            let pair = [
                Math.min(payload.pair[0], payload.pair[1]),
                Math.max(payload.pair[0], payload.pair[1])
            ];

            state.joined_tables[section].push(pair);
        },

        disjoinTables(state, payload) {
            const section = `${payload.section}`;

            const spliceIndex = state.joined_tables[section].findIndex((join) => {
                if (join[0] == payload.pair[0] && join[1] == payload.pair[1]) {
                    return true;
                }

                return false;
            });

            state.joined_tables[section].splice(spliceIndex, 1);
        }
    },
    actions: {
        fetchOrders(context) {
            return new Promise((resolve, reject) => {
                QueueAPI.getList().then(data => {
                    context.commit('setOrders', data.list);
                    resolve();
                }).catch(error => {
                    context.commit('setError', error);
                    reject();
                });
            })
        },
        fetchJoinedTables(context, payload) {
            return new Promise((resolve, reject) => {
                QueueAPI.getJoinedTables().then(data => {
                    context.commit('setJoinedTables', data.joined_tables);
                    resolve();
                }).catch(error => {
                    context.commit('setError', error);
                    reject();
                });
            });
        },
        acceptOrder(context, payload) {
            return new Promise((resolve, reject) => {
                QueueAPI.acceptOrder(
                    payload.order_id, 
                    payload.list, 
                    payload.reason,
                    payload.waiting_time
                )
                    .then(ok => {
                        const index = context.getters.getOrderIndex(payload.order_id);
                        
                        context.commit('setOrderStatus', {
                            index,
                            status: 'serving'
                        });
                        
                        context.commit('setOrderReason', {
                            index,
                            reason: payload.reason
                        });

                        context.commit('setOrderWaitingTime', {
                            index,
                            waiting_time: payload.waiting_time
                        });

                        context.commit('setOrderProcessedDate', {
                            index
                        });
                        
                        context.commit('setOrderWaiter', {
                            index,
                            waiter: context.rootState.waiter.name
                        });
                        resolve();
                    })
                    .catch(error => {
                        context.commit('setError', error);
                        reject();
                    });
            });
        },
        cancelOrder(context, payload) {
            return new Promise((resolve, reject) => {
                QueueAPI.cancelOrder(payload.order_id, payload.reason)
                    .then(ok => {
                        // const index = context.getters.getOrderIndex(payload.order_id);

                        // context.commit('removeOrder', index);

                        resolve();
                    }).catch(error => {
                        context.commit('setError', error);
                        reject();
                    });
            });
        },
        payOrder(context, payload) {
            return new Promise((resolve, reject) => {
                QueueAPI.payOrder(payload.order_id).then(data => {
                    const index = context.getters.getOrderIndex(payload.order_id);

                    context.commit('setOrderStatus', {
                        index,
                        status: 'paying'
                    });

                    resolve();
                }).catch(error => {
                    context.commit('setError', error);
                    reject();
                });
            });
        },
        serveOrder(context, payload) {
            return new Promise((resolve, reject) => {
                QueueAPI.serveOrder(payload.order_id)
                    .then(ok => {
                        const index = context.getters.getOrderIndex(payload.order_id);

                        context.commit('setOrderServedAt', index);

                        resolve();
                    }).catch(error => {
                        context.commit('setError', error);
                        reject();
                    });
            });
        },
        closeOrder(context, payload) {
            return new Promise((resolve, reject) => {
                const index = context.getters.getOrderIndex(payload.order_id);

                QueueAPI.closeOrder(
                    payload.order_id, 
                    payload.pay_method, 
                    payload.discount
                ).then(ok => {
                    setTimeout(() => {

                    context.commit('removeOrder', index);
                    // revert to 10
                    }, 1000 * 1000);

                    context.commit('setOrderStatus', {
                        index,
                        status: 'executed'
                    });

                    resolve();
                }).catch(error => {
                    context.commit('setError', error);
                    reject();
                });
            });
        },
        editOrder(context, payload) {
            return new Promise((resolve, reject) => {
                const order_index = context.getters.getOrderIndex(payload.order_id);
                const order = context.state.orders[order_index];

                QueueAPI.editOrder(payload.order_id, order.list, order.appends)
                    .then(ok => {
                        context.commit('setOrderStatus', {
                            index: order_index,
                            status: 'serving'
                        });
                        resolve();
                    })
                    .catch(error => {
                        context.commit('setError', error);
                        reject();
                    });
            });
        },
        moveOrder(context, payload) {
            return new Promise((resolve, reject) => {
                QueueAPI.moveOrder(payload.order_id, payload.section, payload.table)
                    .then(ok => {
                        resolve();
                    })
                    .catch(error => {
                        context.commit('setError', error);
                        reject();
                    });
            });
        },
        returnOrder(context, payload) {
            return new Promise((resolve, reject) => {
                QueueAPI.returnOrder(payload.order_id).then(data => {
                    resolve();
                }).catch(error => {
                    context.commit('setError', error);
                    reject();
                });
            });
        },

        mergeOrders(context, payload) {
            return new Promise((resolve, reject) => {
                QueueAPI.mergeOrders(payload.primary, payload.secondary)
                    .then(data => {
                        resolve();
                    })
                    .catch(error => {
                        context.commit('setError', error);
                        reject();
                    });
            })
        },

        moveSession(context, payload) {
            return new Promise((resolve, reject) => {
                QueueAPI.moveOrders(payload.orders, payload.target.section, payload.target.table).then(data => {
                    context.state.orders.forEach((order, index) => {
                        if (payload.orders.includes(order._id)) {
                            context.commit('moveOrder', {
                                index,
                                section: payload.target.section,
                                table: payload.target.table
                            });
                        }
                    });
                    
                    resolve();
                }).catch(error => {
                    context.commit('setError', error);
                    reject();
                });
            });
        },


        joinTables(context, payload) {
            return new Promise((resolve, reject) => {
                context.commit('joinTables', payload);
                context.dispatch('syncJoinedTables');
                resolve();
            });
        },
        disjoinTables(context, payload) {
            return new Promise((resolve, reject) => {
                context.commit('disjoinTables', payload);
                context.dispatch('syncJoinedTables');
                resolve();
            });
        },

        syncJoinedTables(context, payload) {
            return new Promise((resolve, reject) => {
                QueueAPI.syncJoinedTables(context.state.joined_tables).then(data => {
                    
                }).catch(error => {
                    context.commit('setError', error);
                    reject();
                });
            });
        },
    },
    getters: {
        getOrderIndex(state) {
            return (order_id) => {
                let index = -1;

                state.orders.forEach((order, idx) => {
                    if (order._id === order_id) {
                        index = idx;
                        return;
                    }
                });

                return index;
            }
        },
        getOrderById(state) {
            return (order_id) => state.orders.find(o => o._id == order_id);
        },
        tabCounters(state) {
            let counters = {
                new: 0,
                processing: 0,
                done: 0
            };

            state.orders.forEach(order => {
                if (order.status === "waiting") {
                    counters.new++;
                } else if (order.status === "serving") {
                    counters.processing++;
                } else if (order.status === "paying") {
                    counters.done++;
                }

                if (order.appends) {
                    counters.new += order.appends.filter(a => a.status == 'waiting').length;
                }
            });
            return counters;
        },
        //
        // This getter builds a structure which can be used to easily display tables grid
        // Basically involves a bunch of v-for's
        //
        tablesUi(state, getters, rootState) {
            //"Blocks" are seperate divs containing grid for all tables in a single section (hall)
            let blocks = [];

            //Map for checking how many orders are there on each table
            let busyTables = {};

            const sections = rootState.cafe.sections;

            if (!sections) return [];

            //Build busyTables map
            state.orders.forEach(order => {
                const key = `${order.section}/${order.table}`;

                if (busyTables[key]) {
                    busyTables[key]++;
                } else {
                    busyTables[key] = 1;
                }
            });

            const TABLES_PER_ROW = 3;

            sections.forEach((_section, section_index) => {
                let block = {
                    name: _section.name,
                    rows: []
                };


                //There is just some math to
                //find how many rows there will be for current block
                let rowsCount = Math.round(_section.tables / TABLES_PER_ROW);

                if (_section.tables % TABLES_PER_ROW > 0) rowsCount++;

                for (let i = 0; i <= rowsCount; i++) block.rows.push([]);

                for (let table = 1; table <= _section.tables; table++) {
                    //This key is used to access busyTables maps
                    const tableKey = `${section_index}/${table}`;

                    const rowIndex = Math.floor((table - 1) / TABLES_PER_ROW);

                    let cell = {
                        section: section_index,
                        tables: [table],

                        title: `${table}`,

                        amount: busyTables[tableKey] || 0
                    };

                    const sectionJoins = state.joined_tables[`${section_index}`];

                    //state.joined_tables contains map of pairs (section_index => array of joined tables)
                    //Array of joined tables contains pairs <table 1, table 2>
                    //If we are at table 1 - change it display title, and tables array
                    //If we are making cell for table 2 - don't show it at all
                    if (sectionJoins) {
                        const currentJoin = sectionJoins.find(joins => joins[0] == table || joins[1] == table);
                    
                        if (currentJoin) {
                            if (currentJoin[0] == table) {
                                cell.tables.push(currentJoin[1]);
                                cell.amount += busyTables[`${section_index}/${currentJoin[1]}`] || 0;
                            } else if (currentJoin[1] == table) {
                                cell = null;
                                //do not show that cell
                            }
                        }
                    }

                    if (cell) {
                        cell.title = `${cell.tables.join('/')}`;
                        block.rows[rowIndex].push(cell);
                    }
                }

                blocks.push(block);
            });
            return blocks;
        },
        getSessionOrders(state, getters, rootState) {
            return (session) => {
                return state.orders.filter((order) => {
                    if (order.section !== session.section) {
                        return false;   
                    }

                    return session.tables.includes(order.table);
                });
            };
        },
        getOrdersForMerge(state, getters) {
            return (order_id) => {
                const order = getters.getOrderById(order_id);

                //we should return array with all orders that can be merged
                //+ the primary order must be first item
                
                return [order].concat(state.orders.filter((o, index) => {
                    if (o._id === order._id) return false;

                    if (o.status !== "paying") {
                        return false;
                    }

                    if (o.table !== order.table || o.section !== order.section)
                        return false;

                    return true;
                }));
            };
        }
    }
}